import { useEffect, useState } from "react";
import "./CountdownSection.scss";

const WEDDING_DATE = new Date("2026-08-21T14:00:00");

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
}

const calculateTimeLeft = (): TimeLeft => {
  const difference = WEDDING_DATE.getTime() - new Date().getTime();

  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
    };
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor(
      (difference / (1000 * 60 * 60)) % 24
    ),
    minutes: Math.floor(
      (difference / (1000 * 60)) % 60
    ),
  };
};

export const CountdownSection = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(
    calculateTimeLeft()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
  <section className="countdown-section">
    <div className="countdown-card">
      <p className="countdown-label">Már csak</p>

      <p className="countdown-time">
        {timeLeft.days} nap {timeLeft.hours} óra{" "}
        {timeLeft.minutes} perc
      </p>

      <p className="countdown-footer">
        van hátra az esküvőnkig
      </p>
          <p className="countdown-rsvp">
        Kérjük, hogy legkésőbb <strong>2026. augusztus 5-ig</strong> töltsétek ki a{" "}
        <a href="#rsvp">
            visszajelző űrlapot
        </a>
        , hogy a szervezéssel kapcsolatban mindent időben elő tudjunk készíteni.
    </p>
    </div>
  </section>
  );
};